export const pagesQaOperationsCoreEn = {
  issueReconciliation: {
    anchorDate: {
      missingTarget: 'No target product selected',
      missingTargetDescription: 'Go back and select a target product.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start defect stocktaking',
      startSuccess: 'Defect stocktaking started'
    },
    instance: {
      data: {
        aiRecommended: 'AI Recommended',
        complete: 'Complete Defect Organizing',
        completeSuccess: 'Defect organizing completed',
        description: 'Review the defects linked to the target product. AI recommended candidates will be highlighted when available.',
        diff: {
          addedBadge: 'Proposed Addition',
          changedBadge: 'Proposed Change',
          field: {
            causeCategory: 'Cause Category',
            causeDetail: 'Cause Detail',
            description: 'Description',
            detectionPhase: 'Detection Phase',
            name: 'Title',
            occurrencePhase: 'Occurrence Phase',
            permanentFix: 'Permanent Fix',
            priority: 'Priority',
            recurrencePrevention: 'Recurrence Prevention',
            reproductionProcess: 'Reproduction Steps',
            severity: 'Severity',
            status: 'Status'
          },
          removedBadge: 'Proposed Removal',
          summaryAdded: 'Added: {{count}}',
          summaryChanged: 'Changed: {{count}}',
          summaryRemoved: 'Removed: {{count}}',
          summaryTitle: 'AI Proposed Changes'
        },
        missingContext: 'Could not load the defect list',
        missingContextDescription: 'The target product for this instance could not be resolved.',
        noIssues: 'No defects are linked to the target product',
        noTask: 'No defect organizing task is available',
        table: {
          headers: {
            externalId: 'External ID',
            name: 'Title',
            priority: 'Priority',
            severity: 'Severity',
            status: 'Status'
          }
        },
        title: 'Defect List'
      },
      detail: {
        assignInline: {
          assignSuccess: 'Assignee set',
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          loading: 'Loading assignee candidates…'
        }
      },
      organizeInDataTab: 'Review in the Data tab',
      organizeInDataTabDescription: 'Review the defect list and complete this task in the Data tab.'
    },
    list: {
      packageEmptyState: {
        description: 'The defect stocktaking operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start defect stocktaking operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Defect Stocktaking',
      taskEmptyState: {
        description: 'Start a new defect stocktaking and it will be listed here.',
        title: 'No defect stocktaking yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      pageTitle: 'Select a Target Product',
      searchPlaceholder: 'Search by product name or code'
    }
  },
  sidebar: {
    defectInventory: 'Defect Inventory',
    enhanceReportInventory: 'Enhancement Report Inventory',
    testAssetInventory: 'Test Asset Inventory',
    testAssetRegistration: 'Test Asset Registration',
    testAssignment: 'Test Assignment',
    testDesign: 'Test Implementation',
    testExecution: 'Test Execution',
    testPlan: 'Test Plan',
    testReview: 'Test Review',
    underDevelopment: 'This operation package is currently under development.'
  },
  testAssignment: {
    instance: {
      data: {
        candidateSearchPlaceholder: 'Search by test set or condition name',
        columns: {
          condition: 'Test Condition',
          production: 'Production',
          status: 'Status',
          testSet: 'Test Set'
        },
        complete: 'Complete',
        filters: {
          any: 'Any',
          level: {
            INTEGRATION: 'Integration',
            SYSTEM: 'System',
            UAT: 'UAT',
            UNIT: 'Unit'
          },
          levelLabel: 'Test Level',
          scope: {
            CHANGE_UNIT: 'Change Unit',
            FULL: 'Full',
            UNDECIDED: 'Undecided'
          },
          scopeLabel: 'Test Scope',
          statusLabel: 'Status'
        },
        noTask: 'No assignment task is available',
        selectSuccess: 'Test cases recorded',
        selectTaskName: 'Select Test Cases',
        status: {
          COMPLETED: 'Completed',
          IN_PROGRESS: 'In Progress',
          NOT_STARTED: 'Not Started'
        }
      },
      detail: {
        assignInline: {
          assignSuccess: 'Assignee set for the selected test cases',
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          loading: 'Loading the selected test cases…',
          targetCount_one: '{{count}} target test case',
          targetCount_other: '{{count}} target test cases'
        }
      },
      selectTestCasesInDataTab: 'Select in the Data tab',
      selectTestCasesInDataTabDescription: 'Select the test cases to assign in the Data tab.'
    },
    list: {
      packageEmptyState: {
        description: 'The test assignment operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start test assignment operations.',
        title: 'No patterns yet'
      },
      startFailed: 'Failed to start test assignment',
      startNew: 'New Test Assignment',
      startSuccess: 'Test assignment started',
      taskEmptyState: {
        description: 'Create a new test assignment and it will be listed here.',
        title: 'No test assignments yet'
      }
    }
  },
  testDesign: {
    anchorDate: {
      missingTarget: 'No target test set selected',
      missingTargetDescription: 'Go back and select a target test set to implement tests for.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start test implementation',
      startSuccess: 'Test implementation started'
    },
    instance: {
      detail: {
        assignInline: {
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          completeSuccess: 'Test case created and assignee set',
          conditionLabel: 'Test Condition',
          loading: 'Loading the test condition…'
        },
        conditionForm: {
          actionPlaceholder: 'e.g. Verify the order can be submitted',
          actionsLabel: 'Expected Behaviors',
          addAction: 'Add a behavior',
          addConstraint: 'Add a constraint',
          addFactor: 'Add a factor',
          addLevel: 'Add a level',
          constraintPlaceholder: 'e.g. Plan A cannot be combined with Coupon X',
          constraintsHint: 'Optional. Add dependency or exclusion rules.',
          constraintsLabel: 'Constraints',
          excludedLabel: 'Excluded',
          factorNamePlaceholder: 'Factor name',
          factorsLabel: 'Factors and Levels',
          levelPlaceholder: 'Level value',
          levelsLabel: 'Levels',
          removeAction: 'Remove behavior {{index}}',
          removeConstraint: 'Remove constraint {{index}}',
          removeFactor: 'Remove factor {{index}}',
          removeLevel: 'Remove level {{index}}',
          saveSuccess: 'Test condition saved',
          submit: 'Save the condition',
          titleLabel: 'Title',
          titlePlaceholder: 'Enter the test condition title',
          validation: {
            actionRequired: 'Add at least one behavior',
            factorRequired: 'Add at least one factor',
            levelRequired: 'Add at least one level',
            required: 'This field is required'
          }
        }
      }
    },
    list: {
      packageEmptyState: {
        description: 'The test implementation operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start test implementation operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Test Implementation',
      taskEmptyState: {
        description: 'Create a new test implementation and it will be listed here.',
        title: 'No test implementations yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      columns: {
        product: 'Product',
        status: 'Status',
        testSet: 'Test Set'
      },
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      pageTitle: 'Select a Target Test Set',
      searchPlaceholder: 'Search by test set or product name',
      status: {
        APPROVED: 'Approved',
        DESIGNING: 'Designing',
        EXECUTED: 'Executed',
        IMPLEMENTING: 'Implementing',
        NOT_EXECUTED: 'Not Executed',
        READY: 'Ready'
      }
    }
  },
  testExecution: {
    anchorDate: {
      missingTarget: 'No target condition selected',
      missingTargetDescription: 'Go back and select a target test condition to run.',
      pageTitle: 'Set the Execution Date',
      start: 'Start',
      startFailed: 'Failed to start test execution',
      startSuccess: 'Test execution started'
    },
    conditionTargetSelection: {
      anchorDateLabel: 'Execution Date',
      columns: {
        condition: 'Test Condition',
        status: 'Status',
        testSet: 'Test Set'
      },
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      noCandidates: 'No test conditions are ready for execution',
      noCandidatesDescription: 'A test condition becomes selectable once its test case sheet has been created.',
      pageTitle: 'Select a Target Test Condition',
      searchPlaceholder: 'Search by test set or condition name',
      status: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In Progress',
        NOT_STARTED: 'Not Started'
      }
    },
    instance: {
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'QA Operations Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      data: {
        columns: {
          actualResult: 'Actual Result',
          condition: 'Test Condition',
          evaluation: 'Evaluation',
          expectedResult: 'Expected Result',
          linkedIssues: 'Linked Defects',
          procedure: 'Procedure',
          target: 'Target'
        },
        complete: 'Complete',
        completeSuccess: 'Test execution completed',
        evaluation: {
          BLOCKED: 'Blocked',
          NG: 'Failed',
          NOT_EXECUTED: 'Not Executed',
          OK: 'Passed',
          SKIP: 'Skipped'
        },
        missingContext: 'Could not resolve the target test condition',
        missingContextDescription: 'The target test condition for this instance could not be loaded.',
        noDetails: 'This test condition has no test items',
        saveFailed: 'Failed to save evaluations',
        saveSuccess: 'Evaluations saved',
        taskName: 'Test Execution'
      },
      progressTitle: 'Progress',
      requestedFor: 'Requested For',
      selectInDataTab: 'Run in the Data tab',
      selectInDataTabDescription: 'Enter and save evaluation results for each test item in the Data tab.',
      tabs: {
        ariaLabel: 'Test execution instance tabs',
        data: 'Data',
        detail: 'Detail'
      }
    },
    list: {
      packageEmptyState: {
        description: 'The test execution operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start test execution operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Test Execution',
      taskEmptyState: {
        description: 'Create a new test execution and it will be listed here.',
        title: 'No test executions yet'
      }
    }
  },
  testPlan: {
    anchorDate: {
      missingTarget: 'No target production selected',
      missingTargetDescription: 'Go back and select a target production to create a test plan for.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start test plan creation',
      startSuccess: 'Test plan creation started'
    },
    instance: {
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'QA Operations Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      progressTitle: 'Progress',
      requestedFor: 'Requested For'
    },
    list: {
      packageEmptyState: {
        description: 'The test plan creation operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start test plan creation operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Test Plan',
      taskEmptyState: {
        description: 'Create a new test plan and it will be listed here.',
        title: 'No test plans yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      pageTitle: 'Select a Target Production',
      searchPlaceholder: 'Search by production or product name'
    }
  },
  testSpecDesign: {
    anchorDate: {
      missingTarget: 'No target test set selected',
      missingTargetDescription: 'Go back and select a target test set to design.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start test spec design',
      startSuccess: 'Test spec design started'
    },
    instance: {
      data: {
        description: 'Select one or more target functions (FUNCTION) from the function tree.',
        missingContext: 'Could not load target function candidates',
        missingContextDescription: 'The target test set could not be resolved or the function tree does not exist. Please review the previous steps.',
        noFunctions: 'No selectable functions',
        noSearchResults: 'No functions match the filters',
        noTask: 'Target function selection task not found',
        saveAndComplete: 'Save and Complete',
        saveSuccess: 'Target functions saved',
        searchPlaceholder: 'Search by name',
        selectedCount: '{{count}} selected',
        table: {
          headers: {
            kind: 'Type',
            name: 'Name',
            publishStatus: 'Publish Status'
          },
          kind: {
            FUNCTION: 'Function',
            MODULE: 'Module',
            PRODUCT: 'Product',
            SUB_MODULE: 'Sub Module'
          },
          publishStatus: {
            IN_DEVELOPMENT: 'In Development',
            PUBLISHED: 'Published',
            UNPUBLISHED: 'Unpublished'
          }
        },
        title: 'Select Target Functions'
      },
      detail: {
        createTestSetForm: {
          designDescriptionLabel: 'Test Target',
          designDescriptionPlaceholder: 'Enter what this test covers',
          designMemoLabel: 'Design Notes',
          designMemoPlaceholder: 'Enter design decisions and rationale',
          designScopesLabel: 'Design Scope',
          nameLabel: 'Test Set Name',
          namePlaceholder: 'Enter the test set name',
          regressionRequiredLabel: 'Regression Required',
          regressionRequiredOptions: {
            notRequired: 'Not required',
            required: 'Required'
          },
          requiredTestDataTypesLabel: 'Required Test Data Types',
          requiredTestDataTypesPlaceholder: 'Enter the required test data types',
          riskObservationLabel: 'Risk Observation',
          riskObservationPlaceholder: 'Enter anticipated risks and observations',
          saveSuccess: 'Test set created',
          submit: 'Create Test Set',
          testDataNotesLabel: 'Test Data Notes',
          testDataNotesPlaceholder: 'Enter notes about the test data',
          testDataPreconditionLabel: 'Test Data Preconditions',
          testDataPreconditionPlaceholder: 'Enter the test data preconditions',
          testLevelLabel: 'Test Level',
          testTypeLabel: 'Test Type',
          validation: {
            required: 'This field is required'
          }
        },
        scope: {
          ABNORMAL: 'Abnormal',
          NORMAL: 'Normal',
          OTHER: 'Other',
          SEMI_NORMAL: 'Semi-normal'
        },
        testLevel: {
          INTEGRATION: 'Integration',
          SYSTEM: 'System',
          UAT: 'UAT',
          UNIT: 'Unit'
        },
        testType: {
          ACCESSIBILITY: 'Accessibility',
          COMPATIBILITY: 'Compatibility',
          FUNCTIONAL: 'Functional',
          INTEROPERABILITY: 'Interoperability',
          MAINTENANCE: 'Maintenance',
          NON_FUNCTIONAL: 'Non-Functional',
          OTHER: 'Other',
          PERFORMANCE: 'Performance',
          PORTABILITY: 'Portability',
          RELIABILITY: 'Reliability',
          SECURITY: 'Security',
          USABILITY: 'Usability'
        }
      },
      selectFunctionsInDataTab: 'Select target functions in the Data tab',
      selectFunctionsInDataTabDescription: 'Select target functions (function tree) in the Data tab.'
    },
    list: {
      packageEmptyState: {
        description: 'The test spec design operation package is not available yet.',
        title: 'Operation package not found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start the test spec design operation.',
        title: 'No patterns yet'
      },
      startNew: 'New Test Spec Design',
      taskEmptyState: {
        description: 'Newly created test spec designs will be listed here.',
        title: 'No test spec designs yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      columns: {
        product: 'Product',
        release: 'Release',
        releaseTest: 'Test Suite',
        status: 'Status'
      },
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      pageTitle: 'Select a Target Test Suite',
      searchPlaceholder: 'Search by test suite, product, or release name',
      status: {
        DONE: 'Done',
        PAUSED: 'Paused',
        PLANNING: 'Planning',
        RUNNING: 'Running'
      }
    }
  }
};